import { KeyboardArrowDown, KeyboardArrowUp, Print } from '@mui/icons-material';
import CircleIcon from '@mui/icons-material/Circle';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import {
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { BootstrapDialog } from 'src/components/common-modals/BootstrapDialog';
import InfoModal from 'src/components/common-modals/info-modal';
import { AddNoteIcon } from 'src/components/therapyPlanning_2.0/commonComponent/therapy-planning-icons';
import useCurrentUser from 'src/hooks/use-current-user';
import { getPayerCateGroup } from 'src/layouts/components/utils-method';
import {
  getTherapistTaskNoteAction,
  resetCreateTherapistTaskNote,
} from 'src/redux/actions/therapySchedulingSkillList';
import useAxiosInterceptor from 'src/services/interceptor';
import trash from '../../../../icons/untitled-ui/duocolor/trash.svg';
import EditTaskTime from '../../EditTaskTime/editTaskTime';
import { ClockIcon, ClockTickIcon, CloseIcon, PencilIcon, PersonStarIcon } from './schedule-icon';
import { AppointmentDisplayType, TaskTypeSvg } from './task-type-svg';
import AssignDefaultTherapist from './assign-default-therapist-dialog';
import SchedulePrintDialog from 'src/pages/therapist-dashboard/todays-activity/SchedulePrintDialog';

function calculateWorkingTime(availableHours: number, productivity: number) {
  // Calculate effective working hours
  const effectiveHours = availableHours * (productivity / 100);

  // Extract hours and minutes
  const hours = Math.floor(effectiveHours);
  const minutes = Math.round((effectiveHours - hours) * 60);

  return `${hours}:${minutes.toString().padStart(2, '0')}`;
}

function isProductiveTime(actualHrs: number, availableHours: number, productivity: number) {
  const effectiveHours = availableHours * (productivity / 100);
  if (actualHrs === 0) return '#757B87';

  return actualHrs >= effectiveHours && actualHrs <= availableHours
    ? '#009A00'
    : actualHrs > availableHours
    ? '#B42318'
    : '#757B87';
}
function calculateAssignedTaskMinutes(task: any) {
  if (!task) return;
  let totalTime =
    (task?.concurrent || 0) +
    (task?.evaluation || 0) +
    (task?.groupTherapy || 0) +
    (task?.insuranceCall || 0) +
    (task?.screening || 0) +
    (task?.therapyMinutes || 0);

  const hours = Math.floor(totalTime / 60);
  const minutes = totalTime % 60;

  // Format in h:MM format (padStart ensures two digits for minutes)
  return `${hours}:${minutes.toString().padStart(2, '0')}`;
}

type Props = {
  therapist: any;
  DeleteTherapistPatient: any;
  providerId: string;
  openEditTimeDialog: any;
  setOpenEditTimeDialog: any;
  index: any;
  updateDailyTasks: any;
  date?: any;
  readDailyTasks: any;
  setIsStatsRefresh?: any;
  isStatsRefresh?: any;
  switchState: 'Productivity Goal' | 'PTIF';
  handleOpenTaskNote: any;
  setIsEditNote: any;
  setCurrentPatientTask: any;
};

const calculateTherapistActualHrs = (therapist: any) => {
  const actualHrs =
    (therapist?.screening || 0) +
    (therapist?.therapyMinutes || 0) +
    (therapist?.groupTherapy || 0) +
    (therapist?.concurrent || 0) +
    (therapist?.evaluation || 0) +
    (therapist?.insuranceCall || 0);
  if (actualHrs === 0) return 0;
  return Math.ceil((actualHrs / 60) * 10) / 10;
};

const TherapistInfoV2 = (props: Props) => {
  const dispatch = useDispatch();
  const {
    DeleteTherapistPatient,
    isStatsRefresh,
    setIsStatsRefresh,
    switchState,
    handleOpenTaskNote,
    setIsEditNote,
    setCurrentPatientTask,
  } = props;
  const [therapist, setTherapist] = useState<any>();
  const [therapistTask, setTherapistTask] = useState<any>();

  const [isLoading, setIsLoading] = useState(false);
  const [isTherapistPatient, setIsTherapistPatient] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [InfoMessage, setInfoMessage] = useState('');
  const [therapistId, setTherapistId] = useState('');
  const [patientTaskDetail, setpatientTaskDetail] = useState('');
  const [therapyInfo, setTherapyInfo] = useState<any>({
    therapyType: '',
    taskType: '',
    taskId: '',
    numberOfMinutes: 0,
    isAssigned: true,
  });
  const [providerId] = useCurrentUser(['providerId']);
  const [openDefaultTherapistDialog, setOpenDefaultTherapistDialog] = useState(false);
  const [isPrintDialogOpen, setIsPrintDialogOpen] = useState(false);

  const getTherapistProfile = useSelector(
    (state: any) => state.getTherapistProfileReducer?.response?.data
  );

  // useEffect(() => {
  //   if (!checkUnassignTask?.isSuccess && checkUnassignTask?.response === null) return;
  //   if (!checkUnassignTask?.isSuccess && checkUnassignTask?.response !== null) {
  //     // console.log('error');
  //     dispatch(therapistAssignUndoReset());
  //   }
  //   if (checkUnassignTask?.isSuccess && checkUnassignTask?.response !== null) {
  //     dispatch(therapistAssignUndoReset());
  //   }
  // }, [checkUnassignTask]);

  const handleTaskListResponse = async (providerId: string, therapistId: string, date: any) => {
    const axiosInstance = useAxiosInterceptor();

    try {
      const response = await axiosInstance.get(
        `/provider/v2/${providerId}/scheduling/available-therapist/${therapistId}/stats?localDate=${date}`
      );
      return response;
    } catch (error) {
      return null;
    }
  };
  useEffect(() => {
    if (providerId && isTherapistPatient && Object.keys(therapist?.assignedPatients).length) {
      setIsLoading(true);

      const response = handleTaskListResponse(
        typeof providerId === 'string' ? providerId : '',
        therapist?.uuid,
        moment(props.date, 'DD-MM-YYYY').format('YYYY-MM-DD')
      );
      response
        .then((value) => {
          const map = new Map();
          value?.data?.data?.forEach((item: any) => {
            if (item?.taskType !== 'GROUP_THERAPY' && item?.taskType !== 'CONCURRENT') {
              if (map?.has(item?.taskType)) {
                const taskObject = map?.get(item?.taskType);
                map?.set(item?.taskType, {
                  ...taskObject,
                  patientName: [...taskObject?.patientName, item?.patientName],
                  payerType: [...taskObject.payerType, item?.payerType],
                  totalTime: [...taskObject?.totalTime, item?.totalTime],
                  taskUuids: [...taskObject.taskUuids, item?.taskUuid],
                  isNoteAvailable: [...taskObject.isNoteAvailable, item?.noteAvailable],
                });
              } else {
                map?.set(item?.taskType, {
                  ...item,
                  patientName: [item?.patientName],
                  payerType: [item?.payerType],
                  totalTime: [item?.totalTime],
                  taskUuids: [item?.taskUuid],
                  isNoteAvailable: [item?.noteAvailable],
                });
              }
            } else {
              if (map?.get(item?.groupUuid)) {
                const taskObject = map?.get(item?.groupUuid);
                map.set(item?.groupUuid, {
                  ...taskObject,
                  patientName: [...taskObject?.patientName, item?.patientName],
                  payerType: [...taskObject?.payerType, item?.payerType],
                  totalTime: Math.max(item?.totalTime, taskObject?.totalTime),
                  taskUuids: [...taskObject.taskUuids, item?.taskUuid],
                  isNoteAvailable: [...taskObject.isNoteAvailable, item?.noteAvailable],
                });
              } else {
                map?.set(item?.groupUuid, {
                  ...item,
                  patientName: [item?.patientName],
                  payerType: [item?.payerType],
                  totalTime: item?.totalTime,
                  taskUuids: [item?.taskUuid],
                  isNoteAvailable: [item?.noteAvailable],
                });
              }
            }
          });
          const newTherapistTaskList: any = [];
          map?.forEach((value) => {
            newTherapistTaskList.push(value);
          });

          setTherapistTask(newTherapistTaskList);
        })
        .finally(() => {
          setIsStatsRefresh(false);
          setIsLoading(false);
        });
    }
  }, [providerId, isTherapistPatient, isStatsRefresh, therapist]);

  useEffect(() => {
    setTherapist(JSON.parse(JSON.stringify(props.therapist)));
  }, [props.therapist]);

  const actualHrs = useMemo(() => {
    return calculateTherapistActualHrs(therapist);
  }, [therapist]);

  useEffect(() => {
    if (actualHrs === 0) {
      setIsTherapistPatient(false);
    }
  }, [actualHrs]);

  const handleEditMin = (e: any, index: number) => {
    if (!props.updateDailyTasks || !props.readDailyTasks) return;
    setTherapyInfo({
      therapyType: e?.taskType,
      taskType: e.groupUuid ? 'group-uuid' : 'task-uuid',
      taskId: e.groupUuid ? e.groupUuid : e.taskUuids[index],
      numberOfMinutes: e.groupUuid ? e.totalTime : e.totalTime[index],
      isAssigned: true,
    });
    handleEditTimeDialog();
  };

  const handleCloseInfo = () => {
    setOpenModal(false);
  };

  const handleEditTimeDialog = () => {
    const updatedArray = [...props.openEditTimeDialog];
    updatedArray[props.index] = !updatedArray[props.index];
    props.setOpenEditTimeDialog(updatedArray);
  };

  const openDeleteModal = () => {
    handleClose();
    setInfoMessage('Are you sure you want to cancel this assignment?');
    setOpenModal(true);
  };

  const handleSinglePatientDelete = (val: any, index: number) => {
    const updatedPatient = {
      ...val,
      taskUuids: val?.taskUuids[index],
      patientName: val?.patientName[index],
      groupUuid: val?.groupUuid,
    };
    setpatientTaskDetail(updatedPatient);
  };

  const handleTherapistPestientList = () => {
    setIsTherapistPatient((prev) => !prev);
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [iseNoteAvailable, setIsNoteAvailable] = useState(false);
  const [isGroupTask, setIsGroupTask] = useState(false);
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    taskUuid: any,
    isNoteAvailable: any
  ) => {
    dispatch(
      getTherapistTaskNoteAction({
        providerId: providerId,
        taskId: taskUuid,
      })
    );
    setIsEditNote(isNoteAvailable);
    setIsNoteAvailable(isNoteAvailable);
    setCurrentPatientTask(taskUuid);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  function sortByName(obj: any) {
    const sortedEntries = Object.entries(obj).sort(([, a]: [any, any], [, b]: [any, any]) => {
      return a?.name?.localeCompare(b?.name);
    });

    const sortedObject = Object.fromEntries(sortedEntries);

    return sortedObject;
  }

  const handlePrint = () => {
    setIsPrintDialogOpen(true);
  };

  const handleClosePrintDialog = () => {
    setIsPrintDialogOpen(false);
  };

  return (
    <>
      <Grid
        container
        sx={{
          borderRadius: '12px',
          minWidth: '322px',
          border: '1px solid #E5E7EB',
          background: '#FFF',
          boxShadow: '0px 1px 10px 0px rgba(0, 0, 0, 0.08)',
          width: '100%',
          alignItems: 'flex-start',
          padding: {
            lg: '5px 10px 10px 10px',
            md: '5px 10px 10px 10px',
            sm: '5px 10px 10px 10px',
            xs: '5px 10px 10px 10px',
          },
          flexDirection: 'column',
          gap: '5px',
          height: '100%',
        }}
      >
        <Grid
          item
          sx={{
            width: '100%',
          }}
        >
          <Grid container>
            <Grid
              item
              sx={{
                padding: '4px 0px',
                display: 'flex',
                justifyContent: 'space-between',
                height: '40px',
                width: '100%',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  alignSelf: 'stretch',
                  gap: '6px',
                  flexWrap: { lg: 'nowrap', md: 'wrap', sm: 'wrap', xs: 'wrap' },
                }}
              >
                <Box
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  gap={'6px'}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Inter ',
                      fontSize: '14px ',
                      fontWeight: '600 ',
                      lineHeight: '22px ',
                    }}
                  >
                    {therapist?.name}
                  </Typography>

                  {therapist?.targetProductivity ? (
                    <Tooltip
                      title={
                        switchState === 'Productivity Goal'
                          ? 'Productivity goal'
                          : 'Projected time in facility'
                      }
                    >
                      <Box
                        display={'flex'}
                        alignItems={'center'}
                        gap={'6px'}
                      >
                        {switchState === 'Productivity Goal' ? (
                          <>
                            <Typography
                              sx={{
                                color: '#9747FF',
                                fontFamily: 'Inter ',
                                fontSize: '12px ',
                                fontWeight: '600 ',
                                lineHeight: '14px ',
                                letterSpacing: '0.2px',
                              }}
                            >
                              {therapist?.targetProductivity}
                              {'% = '}

                              {calculateWorkingTime(
                                therapist?.totalHrs,
                                therapist?.targetProductivity
                              )}
                              {'hr'}
                            </Typography>
                            <CircleIcon
                              sx={{ fontSize: 7 }}
                              color="disabled"
                            />
                          </>
                        ) : (
                          <>
                            <Typography
                              sx={{
                                color: '#9747FF',
                                fontFamily: 'Inter ',
                                fontSize: '12px ',
                                fontWeight: '600 ',
                                lineHeight: '14px ',
                                letterSpacing: '0.2px',
                              }}
                            >
                              {'PTIF = '}
                              {therapist?.ptifcal}
                              {'hr'}
                            </Typography>
                            <CircleIcon
                              sx={{ fontSize: 7 }}
                              color="disabled"
                            />
                          </>
                        )}
                      </Box>
                    </Tooltip>
                  ) : (
                    <>
                      <Typography
                        sx={{
                          color: '#9747FF',
                          fontFamily: 'Inter ',
                          fontSize: '12px ',
                          fontWeight: '600 ',
                          lineHeight: '14px ',
                          letterSpacing: '0.2px',
                        }}
                      >
                        NA
                      </Typography>
                      <CircleIcon
                        sx={{ fontSize: 7 }}
                        color="disabled"
                      />
                    </>
                  )}
                </Box>
                <Box
                  display={'flex'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Tooltip title="Assigned time">
                      <Typography
                        sx={{
                          color: isProductiveTime(
                            actualHrs,
                            therapist?.totalHrs,
                            therapist?.targetProductivity
                          ),
                          fontFamily: 'Inter ',
                          fontSize: '12px ',
                          fontWeight: '600 ',
                          lineHeight: '12px ',
                          letterSpacing: '0.15px',
                        }}
                      >
                        {calculateAssignedTaskMinutes(therapist)}
                        {`hr`}
                      </Typography>
                    </Tooltip>{' '}
                    <ClockTickIcon
                      color={isProductiveTime(
                        actualHrs,
                        therapist?.totalHrs,
                        therapist?.targetProductivity
                      )}
                    />
                    <Typography sx={{ color: '#757B87', fontSize: '12px', fontWeight: 500 }}>
                      {'/'}
                    </Typography>
                    <Tooltip title="Available time">
                      <Typography
                        sx={{
                          color: '#757B87',
                          fontFamily: 'Inter ',
                          fontSize: '12px ',
                          fontWeight: '600 ',
                          lineHeight: '12px ',
                          letterSpacing: '0.15px',
                        }}
                      >
                        {therapist?.totalHrs}
                        {`hr `}
                      </Typography>
                    </Tooltip>
                    <ClockIcon color="#757B87" />
                  </Box>
                </Box>
              </Box>
              <Box
                display={'flex'}
                alignItems={'center'}
              >
                <Box>
                  <Tooltip title="Print daily schedule">
                    <IconButton
                      onClick={handlePrint}
                      disabled={actualHrs === 0}
                      sx={{ color: '#6366F1', width: '40px', height: '40px' }}
                    >
                      <Print />
                    </IconButton>
                  </Tooltip>
                </Box>
                <IconButton onClick={handleTherapistPestientList}>
                  {isTherapistPatient ? (
                    <KeyboardArrowUp sx={{ color: '#6C737F' }} />
                  ) : (
                    <KeyboardArrowDown sx={{ color: '#6C737F' }} />
                  )}
                </IconButton>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {actualHrs !== 0 && !isTherapistPatient ? (
          therapist?.uuid && (
            <Droppable droppableId={therapist?.uuid}>
              {(provided, snapshot) => (
                <Grid
                  {...provided.droppableProps}
                  ref={(el) => {
                    provided.innerRef(el);
                  }}
                  item
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    padding: '6px',
                    alignItems: 'center',
                    minHeight: '40px',
                    borderRadius: '8px',
                    width: '100%',
                    gap: '6px',
                    border: snapshot.isDraggingOver
                      ? '1px solid #007bff'
                      : '1px dashed rgba(99, 102, 241, 0.50)',
                    background: snapshot.isDraggingOver ? '#e0f0ff' : '#F8F9FA',
                    position: 'relative',
                    // animation: snapshot.isDraggingOver ? 'dropAnimation 0.5s ease-in-out' : 'none',
                  }}
                >
                  {Object.keys(sortByName(therapist.assignedPatients)).map(
                    (patientId: any, index: number) => {
                      const patient = therapist.assignedPatients[patientId];
                      return (
                        <Draggable
                          key={`${patientId}`}
                          draggableId={`${patientId}~${index}${therapist?.uuid}`}
                          index={index}
                        >
                          {(provided) => (
                            <Box
                              key={index}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <Chip
                                variant="outlined"
                                size="small"
                                label={patient?.name}
                                sx={{
                                  backgroundColor: '#E5E7EB',
                                  color: '#111927',
                                  borderRadius: '20px',
                                  borderBottom: `2px solid ${getPayerCateGroup(patient?.PayerType)
                                    ?.borderColor}`,
                                  background: 'rgba(17, 25, 39, 0.04)',
                                  fontFamily: 'Inter ',
                                  fontSize: '12px ',
                                  textWrap: 'nowrap',
                                  cursor: 'grab',
                                }}
                                key={patientId}
                              />
                            </Box>
                          )}
                        </Draggable>
                      );
                    }
                  )}

                  {provided.placeholder}
                  <Box sx={{ display: 'flex', position: 'absolute', right: '0px', bottom: '0px' }}>
                    <IconButton
                      onClick={() => setOpenDefaultTherapistDialog(true)}
                      sx={{
                        borderTop: '1px dashed rgba(99, 102, 241, 0.50)',
                        borderLeft: '1px dashed rgba(99, 102, 241, 0.50)',
                        borderRadius: '8px 0px',
                        background: ' #FFF',
                      }}
                    >
                      <PersonStarIcon />
                    </IconButton>
                  </Box>
                </Grid>
              )}
            </Droppable>
          )
        ) : actualHrs === 0 && isTherapistPatient ? (
          therapist?.uuid && (
            <Droppable droppableId={therapist?.uuid}>
              {(provided, snapshot) => (
                <Grid
                  {...provided.droppableProps}
                  ref={(el) => {
                    provided.innerRef(el);
                  }}
                  item
                  sx={{
                    display: 'flex',
                    padding: '6px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '90px',
                    borderRadius: '8px',
                    border: snapshot.isDraggingOver
                      ? '1px solid #007bff'
                      : '1px dashed rgba(99, 102, 241, 0.50)',
                    background: snapshot.isDraggingOver ? '#e0f0ff' : '#F8F9FA',
                    width: '100%',
                    position: 'relative',
                    // animation: snapshot.isDraggingOver ? 'dropAnimation 0.5s ease-in-out' : 'none',
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      color: 'rgba(17, 25, 39, 0.38)',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      pointerEvents: 'none',
                    }}
                  >
                    Drag and Drop Patients
                  </Typography>
                  {provided.placeholder}
                </Grid>
              )}
            </Droppable>
          )
        ) : isTherapistPatient ? (
          isLoading ? (
            <CircularProgress
              sx={{ margin: 'auto' }}
              color="info"
            />
          ) : (
            therapist?.uuid && (
              <Droppable droppableId={therapist?.uuid}>
                {(provided) => (
                  <Grid
                    ref={provided.innerRef}
                    key={therapist?.uuid}
                    {...provided.droppableProps}
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px',
                      ':hover': {
                        cursor: 'grab',
                      },
                    }}
                  >
                    {therapistTask?.map((single_Patient: any, index: number) => (
                      <Grid
                        container
                        flexDirection={'column'}
                        gap={1}
                        sx={{
                          display: 'flex',
                          padding: '6px',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          minHeight: '40px',
                          borderRadius: '8px',
                          border: '1px dashed rgba(99, 102, 241, 0.50)',
                          // width: 'fit-content',
                          width: '100%',
                          flexWrap: 'nowrap',
                          overflow: 'hidden',
                          pointerEvents: !single_Patient?.isCompleted ? 'inherit' : 'none',
                          backgroundColor: 'white',
                        }}
                      >
                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '94%',
                            margin: 'auto',
                            opacity: !single_Patient?.isCompleted ? '100%' : '17%',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              gap: '6px',
                            }}
                          >
                            {single_Patient?.taskType && (
                              <React.Fragment>
                                <TaskTypeSvg
                                  isTaskIcon={true}
                                  taskType={single_Patient?.taskType.replace('_', ' ')}
                                />
                              </React.Fragment>
                            )}
                            <Typography sx={{ fontSize: '14px', color: '#4338CA' }}>
                              {((single_Patient?.taskType === 'CONCURRENT' ||
                                single_Patient?.taskType === 'GROUP_THERAPY') &&
                                single_Patient?.groupName) ||
                                AppointmentDisplayType[
                                  single_Patient?.taskType as keyof typeof AppointmentDisplayType
                                ]}
                            </Typography>
                            <IconButton
                              onClick={() => {
                                setTherapistId(therapist?.uuid);
                                setpatientTaskDetail(single_Patient);
                                openDeleteModal();
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          </Box>

                          {(single_Patient?.taskType === 'CONCURRENT' ||
                            single_Patient?.taskType === 'GROUP_THERAPY') && (
                            <Box
                              onClick={() => {
                                setTherapistId(therapist?.uuid);
                                handleEditMin(single_Patient, index);
                                setpatientTaskDetail(single_Patient);
                              }}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                gap: '5px',
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: '13px',
                                  fontWeight: 500,
                                  cursor: 'pointer',
                                  color: 'var(--secondary-main, #384250)',
                                  lineHeight: '14px',
                                }}
                              >
                                {single_Patient?.totalTime}&nbsp;min
                              </Typography>
                              <PencilIcon />
                            </Box>
                          )}
                        </Grid>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', width: '100%', gap: '8px' }}>
                          {single_Patient?.patientName?.map((patient: any, index: number) =>
                            single_Patient?.taskType !== 'CONCURRENT' &&
                            single_Patient?.taskType !== 'GROUP_THERAPY' ? (
                              <Draggable
                                key={single_Patient?.taskUuids[index]}
                                draggableId={`${single_Patient?.taskUuids[index]}+${index}`}
                                index={index}
                              >
                                {(provided, snapshot) => (
                                  <Stack
                                    key={index}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    sx={{
                                      '&:hover': {
                                        background: 'rgba(17, 25, 39, 0.04)',
                                      },
                                      borderRadius: '12px',
                                      padding: '15px 0px 15px 10px',
                                      height: '22px',
                                      alignItems: 'center',
                                      border: snapshot.isDragging ? '1px solid #007bff' : 'none',
                                      background: snapshot.isDragging ? '#e0f0ff' : '#1119270A',
                                      borderBottom: `2px solid ${getPayerCateGroup(
                                        single_Patient?.payerType[index]
                                      )?.borderColor}`,
                                      // animation: snapshot.isDragging
                                      //   ? 'dropAnimation 0.5s ease-in-out'
                                      //   : 'none',
                                      //commented the code, because of this it lags when performing fast operation
                                    }}
                                    flexDirection={'row'}
                                  >
                                    <Typography
                                      sx={{
                                        fontFamily: 'Inter ',
                                        fontSize: '13px ',
                                        fontWeight: '500 ',
                                        letterSpacing: '0.14px',
                                      }}
                                    >
                                      {`${patient}`}
                                    </Typography>
                                    <Box
                                      onClick={() => {
                                        setTherapistId(therapist?.uuid);
                                        handleEditMin(single_Patient, index);
                                        handleSinglePatientDelete(single_Patient, index);
                                      }}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        gap: '5px',
                                      }}
                                    >
                                      <Typography
                                        noWrap={true}
                                        sx={{
                                          fontSize: '13px',
                                          fontWeight: 500,
                                          display: 'flex',
                                          width: '100%',
                                          color: '#111927',
                                          pl: '8px',
                                        }}
                                      >
                                        {single_Patient?.totalTime[index]}&nbsp;min
                                      </Typography>
                                      {!snapshot.isDragging && <PencilIcon forSingleCard />}
                                    </Box>
                                    {!snapshot.isDragging && (
                                      <IconButton
                                        id="basic-button"
                                        aria-controls={open ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        onClick={(e) => {
                                          setIsGroupTask(false);
                                          setTherapistId(therapist?.uuid);
                                          handleSinglePatientDelete(single_Patient, index);
                                          handleClick(
                                            e,
                                            single_Patient?.taskUuids[index],
                                            single_Patient?.isNoteAvailable[index]
                                          );
                                        }}
                                      >
                                        <MoreVertRoundedIcon
                                          sx={{
                                            fontSize: '18px',
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </Stack>
                                )}
                              </Draggable>
                            ) : (
                              <Stack
                                key={index}
                                sx={{
                                  background: '#1119270A',
                                  borderRadius: '12px',
                                  padding: '15px 0px 15px 10px',
                                  height: '22px',
                                  alignItems: 'center',
                                  cursor: 'auto',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  borderBottom: `2px solid ${getPayerCateGroup(
                                    single_Patient?.payerType[index]
                                  )?.borderColor}`,
                                }}
                                flexDirection={'row'}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: 'Inter ',
                                    fontSize: '13px ',
                                    fontWeight: '500 ',
                                    letterSpacing: '0.14px',
                                    pr: getTherapistProfile?.currentRoles?.includes('dor')
                                      ? '0px'
                                      : '10px',
                                  }}
                                >
                                  {`${patient}`}
                                </Typography>
                                {getTherapistProfile?.currentRoles?.includes('dor') ? (
                                  <IconButton
                                    id="basic-button"
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={(e) => {
                                      setIsGroupTask(true);
                                      handleClick(
                                        e,
                                        single_Patient?.taskUuids[index],
                                        single_Patient?.isNoteAvailable[index]
                                      );
                                    }}
                                  >
                                    <MoreVertRoundedIcon
                                      sx={{
                                        fontSize: '18px',
                                      }}
                                    />
                                  </IconButton>
                                ) : null}
                              </Stack>
                            )
                          )}
                        </Box>
                      </Grid>
                    ))}
                    {provided.placeholder}
                  </Grid>
                )}
              </Droppable>
            )
          )
        ) : (
          therapist?.uuid && (
            <Droppable droppableId={therapist?.uuid}>
              {(provided, snapshot) => (
                <Grid
                  {...provided.droppableProps}
                  ref={(el) => {
                    provided.innerRef(el);
                  }}
                  item
                  sx={{
                    display: 'flex',
                    padding: '6px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '40px',
                    borderRadius: '8px',
                    // marginTop: '1rem',
                    border: snapshot.isDraggingOver
                      ? '1px solid #007bff' // Style when item is being dragged
                      : '1px dashed rgba(99, 102, 241, 0.50)',
                    background: snapshot.isDraggingOver ? '#e0f0ff' : '#F8F9FA',
                    width: '100%',
                    position: 'relative',
                    // animation: snapshot.isDraggingOver ? 'dropAnimation 0.5s ease-in-out' : 'none',
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      color: 'rgba(17, 25, 39, 0.38)',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      pointerEvents: 'none',
                    }}
                  >
                    Drag and Drop Patients
                  </Typography>
                  {provided.placeholder}
                </Grid>
              )}
            </Droppable>
          )
        )}
      </Grid>
      <BootstrapDialog
        onClose={handleCloseInfo}
        aria-labelledby="customized-dialog-title"
        open={openModal}
      >
        <InfoModal
          close={handleCloseInfo}
          title="Cancel assignment?"
          message={InfoMessage}
          button={{ saveLabel: 'Yes', closeLabel: 'No' }}
          displayTime={false}
          handleSaveBtn={() => {
            handleCloseInfo();
            DeleteTherapistPatient(therapistId, patientTaskDetail);
          }}
        />
      </BootstrapDialog>
      <BootstrapDialog
        onClose={handleEditTimeDialog}
        aria-labelledby="customized-dialog-title"
        open={props.openEditTimeDialog[props.index] || false}
      >
        <EditTaskTime
          providerId={props.providerId}
          handleEditTimeDialog={handleEditTimeDialog}
          therapyInfo={therapyInfo}
          handleDeleteMinuteZero={() => {
            DeleteTherapistPatient(therapistId, patientTaskDetail);
          }}
        />
      </BootstrapDialog>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {getTherapistProfile?.currentRoles?.includes('dor') && (
          <MenuItem
            sx={{ gap: '10px', fontWeight: '500', color: '#6C737F' }}
            onClick={() => {
              dispatch(resetCreateTherapistTaskNote());
              handleClose();
              handleOpenTaskNote();
            }}
          >
            <AddNoteIcon />
            {iseNoteAvailable ? 'Edit a Note' : 'Add a Note'}
          </MenuItem>
        )}
        {!isGroupTask && (
          <MenuItem
            sx={{ gap: '10px', fontWeight: '500', color: '#6C737F' }}
            onClick={() => {
              openDeleteModal();
            }}
          >
            <img
              alt=""
              src={trash}
            />
            Cancel Assignment
          </MenuItem>
        )}
      </Menu>

      <BootstrapDialog
        onClose={() => setOpenDefaultTherapistDialog(false)}
        aria-labelledby="customized-dialog-title"
        open={openDefaultTherapistDialog}
        PaperProps={{ style: { maxWidth: '400px' } }}
      >
        <AssignDefaultTherapist
          therapist={therapist}
          setOpenDefaultTherapistDialog={setOpenDefaultTherapistDialog}
        />
      </BootstrapDialog>
      <SchedulePrintDialog
        providerUUID={therapist?.uuid}
        dateString={moment(props.date, 'DD-MM-YYYY').format('YYYY-MM-DD')}
        open={isPrintDialogOpen}
        onClose={handleClosePrintDialog}
      />
    </>
  );
};

export default TherapistInfoV2;
